export default function registerPasswordResetScreen(Alpine) {
    Alpine.data('passwordResetScreen', () => ({
        showPasswordConfirm: false,

        handleSubmit() {
            this.$refs.passwordResetForm?.requestSubmit()
        },
    }))
}
